import {Modules} from '@buncha/utils/types';

export interface Locale {
  title?: {[key: string]: any};
  body?: {[key: string]: any};
  button?: {[key: string]: any};
  toast?: {[key: string]: any};
}

export interface Screen {
  [key: string]: Locale;
}

export type Module = {
  [key in Modules]: Screen;
};

// eslint-disable-next-line no-shadow
export enum LocalizationParamKeys {
  env = 'env',
  language = 'language',
  version = 'version',
}

export type LocalizationParameters = {
  [key in LocalizationParamKeys]: string;
};

export interface LocalizationFileData {
  parameters: LocalizationParameters;
  modules: Module;
}

// eslint-disable-next-line no-shadow
export enum Components {
  components = 'components',
}
